/* eslint-disable react-hooks/exhaustive-deps */
// External deps
import { useState, createContext, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
// Internal deps
import { useParams } from 'react-router-dom';

import useToast from '../hooks/useToast';
import {
  getCalendarLines,
  getLineDataByDay,
  getLinesByDayV2,
  getLinesByWeekNew,
  getLinesMonthHeader
} from '../services/workReport';
import { workReportLineStatus } from '../utils/dataStatus';

import { useWorkReportModals } from './WorkReportModalsContext';
import LoaderContext from './LoaderProvider';
import { useDetailServiceRequest } from './DetailServiceRequestProvider';

const WorkReportContext = createContext();

export default WorkReportContext;

const enumColors = {
  green: '#FFFFFF,#219E66',
  blue: '#FFFFFF,#159AD8',
  red: '#FFFFFF,#FF6666',
  greenLight: '#219E66,#FFFFFF'
};

export function WorkReportProvider({ children }) {
  const [startDate, setStartDate] = useState('');
  const [viewOptions, setViewOptions] = useState('daily');
  const [searchValue, setSearchValue] = useState('');
  const [endDate, setEndDate] = useState('');
  const [workReportId, setWorkReportId] = useState(null);
  const [calendarDate, setCalendarDate] = useState(null);
  const [devolutionDate, setDevolutionsDate] = useState([]);
  const [notifiedDate, setNotifiedDate] = useState([]);
  const [isNotificationWindowOpen, setIsNotificationWindowOpen] = useState();
  const [forceWindow, setForceWindow] = useState(null);
  const [firstDayOfWeek, setFirstDayOfWeek] = useState();
  const [lastDayOfWeek, setLastDayOfWeek] = useState();
  const [firstDayWithReturnedLine, setFirstDayWithReturnedLine] = useState();
  const [lastDayWithReturnedLine, setLastDayWithReturnedLine] = useState();
  const [linesByDay, setLinesByDay] = useState([]);
  const [linesByWeek, setLinesByWeek] = useState([]);
  const [linesByMonth, setLinesByMonth] = useState([]);
  const [calendarDates, setCalendarDates] = useState([]);
  const [idWorkReportLine, setIdWorkReportLine] = useState([]);
  const [infoSelectedLine, setInfoSelectedLine] = useState(null);
  const [selectedLine, setSelectedLine] = useState({
    index: 0
  });
  const [idWorkLineMonthly, setIdWorkLineMonthly] = useState(0);
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const { setSelectedDate } = useWorkReportModals();
  const { id: serviceRequestId } = useParams();

  const { details } = useDetailServiceRequest();

  // useEffect(
  //   () => () => {
  //     // Valores originales
  //     setWorkReportId(null);
  //     setLinesByDay([]);
  //     setLinesByWeek([]);
  //     setLinesByMonth([]);
  //     setCalendarDate(null);
  //     setStartDate('');
  //     setEndDate('');
  //     setViewOptions('daily');
  //     setSearchValue('');
  //     setDevolutionsDate([]);
  //     setNotifiedDate([]);
  //     setIsNotificationWindowOpen(undefined);
  //     setForceWindow(null);
  //     setFirstDayOfWeek(undefined);
  //     setLastDayOfWeek(undefined);
  //     setFirstDayWithReturnedLine(undefined);
  //     setLastDayWithReturnedLine(undefined);
  //     setCalendarDates([]);
  //     setIdWorkReportLine([]);
  //     setInfoSelectedLine(null);
  //     setSelectedLine({ index: 0 });
  //     setIdWorkLineMonthly(0);
  //   },
  //   [serviceRequestId]
  // );
  const getNotificationWindowState = async () => {
    try {
      const { forzarVentanaNotificacion } = details;

      setForceWindow(forzarVentanaNotificacion);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  useEffect(() => {
    if (details && serviceRequestId) {
      getNotificationWindowState();
    }
  }, [serviceRequestId, details]);

  const fetchLinesByDay = async (initialDate = calendarDate, search = searchValue, filter = []) => {
    if (workReportId && calendarDate) {
      setLoader(true);

      try {
        setCalendarDate(initialDate);

        const filterBody = {
          posicionesLineas: filter?.posicionesLineas?.map((pos) => ({
            posicionId: pos?.posicionId,
            posicion: pos?.posicion,
            linea: pos?.linea,
            lineaId: pos?.lineaId
          }))
        };
        const body = {
          ...(search && { buscar: search }),
          fecha: initialDate,
          ...filterBody,
          forzarVentanaNotificacion: forceWindow
        };

        const res = await getLinesByDayV2(workReportId, body);
        const calendarInfo = await getLineDataByDay(workReportId, initialDate);

        const adapter = res?.lineas.map((line) => ({
          ...line,
          fecha: res?.fechaSeleccionada,
          positionName: `${line.numeroPosicion} - ${line.descripcionPosicionSap}`,
          lineName: `${line.numeroLinea} - ${line.descripcionLineaSap}`,
          disabled: !(
            line.estadoEnum === workReportLineStatus.pendiente ||
            line.estadoEnum === workReportLineStatus.devolver
          ),
          flujoMobile: calendarInfo.flujoMobile
        }));

        setIsNotificationWindowOpen(res?.ventanaActiva);
        setLinesByDay(adapter);
        setFirstDayWithReturnedLine(calendarInfo.primeraFecha);
        setLastDayWithReturnedLine(calendarInfo.ultimaFecha);
        setDevolutionsDate(calendarInfo.fechasConCantidadesNotificadasDevueltas);
        setNotifiedDate(calendarInfo.fechasConCantidadesNotificadas);
        setFirstDayWithReturnedLine(calendarInfo.primeraFecha);
        setLastDayWithReturnedLine(calendarInfo.ultimaFecha);
        setDevolutionsDate(calendarInfo.fechasConCantidadesNotificadasDevueltas);
        setNotifiedDate(calendarInfo.fechasConCantidadesNotificadas);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: error.message
        });
      }
    }
  };

  const fetchLinesByWeek = async (
    initialDate = calendarDate,
    search = searchValue,
    filter = []
  ) => {
    if (workReportId && calendarDate) {
      setLoader(true);
      setCalendarDate(initialDate);
      try {
        const filterBody = {
          posicionesLineas: filter?.posicionesLineas.map((pos) => ({
            posicionId: pos?.posicionId,
            posicion: pos?.posicion,
            linea: pos?.linea,
            lineaId: pos?.lineaId
          }))
        };

        const body = {
          ...(search && { buscar: search }),
          fecha: initialDate,
          ...filterBody,
          forzarVentanaNotificacion: forceWindow
        };

        const resp = await getLinesByWeekNew(workReportId, body);
        const calendarInfo = await getLineDataByDay(workReportId, initialDate);
        const fechasFlujoMobile = calendarInfo?.fechasFlujoMobile || [];

        if (resp?.parteTrabajoLineas.length) {
          const adapter = resp?.parteTrabajoLineas?.map((position) => ({
            ...position,
            lineas: position.lineas?.map((linea) => ({
              ...linea,
              partesDiarios: linea.partesDiarios?.map((parte) => ({
                ...parte,
                flujoMobile: fechasFlujoMobile.includes(parte.fecha)
              }))
            })),
            positionName: `${position.numeroPosicion} - ${position.descripcionPosicionSAP}`
          }));

          setStartDate(calendarInfo.primeraFecha);
          setEndDate(calendarInfo.ultimaFecha);
          setFirstDayOfWeek(resp?.primerDiaSemana);
          setLastDayOfWeek(resp?.ultimoDiaSemana);
          setLinesByWeek(adapter);
        } else {
          setLinesByWeek([]);
        }
        setFirstDayWithReturnedLine(calendarInfo.primeraFecha);
        setLastDayWithReturnedLine(calendarInfo.ultimaFecha);
        setDevolutionsDate(calendarInfo.fechasConCantidadesNotificadasDevueltas);
        setNotifiedDate(calendarInfo.fechasConCantidadesNotificadas);
        setFirstDayWithReturnedLine(calendarInfo.primeraFecha);
        setLastDayWithReturnedLine(calendarInfo.ultimaFecha);
        setDevolutionsDate(calendarInfo.fechasConCantidadesNotificadasDevueltas);
        setNotifiedDate(calendarInfo.fechasConCantidadesNotificadas);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: error.message
        });
      }
    }
  };

  const fetchLinesByMonth = async (search = searchValue) => {
    setLoader(true);
    try {
      const resp = await getLinesMonthHeader(workReportId, search);

      setLinesByMonth(resp);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const setVariant = (color) => {
    switch (color) {
      case enumColors.green:
        return 'green';
      case enumColors.blue:
        return 'blue';
      case enumColors.red:
        return 'red';
      case enumColors.greenLight:
        return 'green-light';
      default:
        return '';
    }
  };

  const mapWorkReportCalendar = (response, un) =>
    response.partesDiarios.map((pt) => {
      const variant = setVariant(pt.colores);

      setInfoSelectedLine({
        unidadMedida: un,
        cargadas: response.cargadas,
        pendientes: response.pendientes,
        aprobadas: response.aprobadas,
        fijadas: response.fijadas,
        devueltas: response.devueltas
      });
      setIdWorkLineMonthly(response.partesDiarios.length ? response.partesDiarios[0].id : 0);

      return {
        ...pt,
        variant
      };
    });

  const fetchMonthlyLines = async (
    idWRLine = idWorkReportLine,
    date = calendarDate,
    goToFirstDay = null,
    goToLastDay = null,
    un = '-'
  ) => {
    try {
      setLoader(true);

      const response = await getCalendarLines(idWRLine, date, goToFirstDay, goToLastDay);
      const workReportCalendar = mapWorkReportCalendar(response, un);

      if (goToFirstDay !== null || goToLastDay !== null) {
        const initDateWorkLine = workReportCalendar.length ? workReportCalendar[0].fecha : date;

        setCalendarDate(initDateWorkLine);
      } else {
        setCalendarDate(date);
      }

      setCalendarDates(workReportCalendar);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  // idWorkReportLine: solo para view monthly
  const fetchLines = async (date, search = false, filter = []) => {
    if (viewOptions.includes('daily')) {
      await fetchLinesByDay(date, searchValue, filter);
    }
    if (viewOptions.includes('weekly')) {
      await fetchLinesByWeek(date, searchValue, filter);
    }
    if (viewOptions.includes('monthly')) {
      if (!search) {
        const um = infoSelectedLine?.unidadMedida || undefined;

        await fetchMonthlyLines(idWorkReportLine, date, um);
      } else {
        await fetchLinesByMonth(searchValue);
      }
    }
  };

  useEffect(() => {
    setSelectedDate(calendarDate);
  }, [calendarDate]);

  return (
    <WorkReportContext.Provider
      value={{
        calendarDate,
        calendarDates,
        devolutionDate,
        notifiedDate,
        endDate,
        fetchLines,
        fetchLinesByDay,
        fetchLinesByMonth,
        fetchLinesByWeek,
        fetchMonthlyLines,
        firstDayOfWeek,
        firstDayWithReturnedLine,
        idWorkLineMonthly,
        idWorkReportLine,
        infoSelectedLine,
        lastDayOfWeek,
        lastDayWithReturnedLine,
        linesByDay,
        linesByMonth,
        linesByWeek,
        searchValue,
        selectedLine,
        isNotificationWindowOpen,
        forceWindow,
        setCalendarDate,
        setCalendarDates,
        setEndDate,
        setIdWorkReportLine,
        setInfoSelectedLine,
        setLinesByDay,
        setLinesByMonth,
        setSearchValue,
        setSelectedLine,
        setStartDate,
        setViewOptions,
        setWorkReportId,
        startDate,
        viewOptions,
        workReportId
      }}
    >
      {children}
    </WorkReportContext.Provider>
  );
}

WorkReportProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired
};
